import {combineReducers} from '@reduxjs/toolkit';
import {
  ambientWeatherReducer,
  billingReducer,
  dataReducer,
  davisReducer,
  ecowittReducer,
  featureFlagsReducer,
  locationReducer,
  mapPreferencesReducer,
  myAcuriteReducer,
  myWeatherReducer,
  netatmoEnergyReducer,
  netatmoWeatherReducer,
  selectPublicConfig,
  setPublicConfig,
  staffElevationReducer,
  uiInteractionReducer,
  userPreferenceReducer,
  userReducer,
  weatherDataReducer,
  weatherReducer,
  weatherflowReducer,
  wundergroundReducer,
} from '@smartmixin/core';
import prefsReducer from './prefs';

export const reducerObj = {
  uiInteraction: uiInteractionReducer,
  prefs: prefsReducer,
  user: userReducer,
  userPreference: userPreferenceReducer,
  billing: billingReducer,
  featureFlags: featureFlagsReducer,
  netatmoWeather: netatmoWeatherReducer,
  netatmoEnergy: netatmoEnergyReducer,
  data: dataReducer,
  weather: weatherReducer,
  weatherData: weatherDataReducer,
  // The webapp has no location screens, but core's shared selectors do not
  // know that: `selectCoverageStations` reads the location forecast store
  // alongside the weather one, so an unregistered slice is an undefined read,
  // not an unused one (SMARTMIXIN-WEB-5C). Persisted like `weather` — it is
  // account data, not ephemeral UI.
  location: locationReducer,
  // The account's My weather order (backend#266); reset at LOGOUT below.
  myWeather: myWeatherReducer,
  davis: davisReducer,
  weatherflow: weatherflowReducer,
  ambientWeather: ambientWeatherReducer,
  wunderground: wundergroundReducer,
  ecowitt: ecowittReducer,
  myAcurite: myAcuriteReducer,
  // In memory only: blacklisted in ./persistConfig (a credential).
  staffElevation: staffElevationReducer,
  // What /map shows (FE #327). Persisted: a device preference, like `prefs`.
  mapPreferences: mapPreferencesReducer,
};

const appReducer = combineReducers(reducerObj);

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    // No `ui` here: the webapp has no such reducer (mobile does). Keeping it
    // put `ui: undefined` on the object as an OWN key, and combineReducers
    // warns on Object.keys regardless of value -- the "Unexpected key" line in
    // the test output was this, not rehydration (#190).
    //
    // `mapPreferences` is kept for its layer toggles. It is kept here, ahead
    // of appReducer, so that its own LOGOUT case runs on the stored state and
    // clears only the saved forecast map; dropping it here would reset the
    // toggles too.
    //
    // `featureFlags` keeps only its public configuration (`GET
    // /api/app/flags`: flags, rollouts, versions, #379), as on mobile: it is
    // not the session's. The `/me` flags and Stripe config start over.
    const {prefs, userPreference, mapPreferences} = state;
    const featureFlags = featureFlagsReducer(
      undefined,
      setPublicConfig(selectPublicConfig(state ?? {})),
    );
    state = {prefs, userPreference, mapPreferences, featureFlags};
  }

  return appReducer(state, action);
};

export default rootReducer;
